import React, { useMemo } from "react";
import { UniversalEntityPage } from "@/components/shared/UniversalEntityPage";
import { useTicketHooks } from "@/features/tickets/hooks/ticket-hooks";
import { getEntityTableConfig } from "@/lib/entity-registry";
import type { Tickets } from "@/src/gql/graphql";

const TICKET_CONFIG = getEntityTableConfig<Tickets>("tickets");
import type { CompanyTabComponentProps } from "@/lib/types/company";

export const CompanyTickets: React.FC<CompanyTabComponentProps> = ({ companyId }) => {
  // Create hooks for tickets
  const ticketHooks = useTicketHooks();

  // Create custom filters to filter tickets by company
  const customFilters = useMemo(
    () => ({
      // Filter tickets by company_id directly
      company_id: companyId,
    }),
    [companyId]
  );

  return (
    <UniversalEntityPage
      entityName="tickets"
      config={TICKET_CONFIG}
      hooks={ticketHooks}
      filterPreset="all"
      title="Company Tickets"
      description={"View and manage tickets for this company"}
      storageKey="company-tickets-column-preferences"
      customFilters={customFilters}
      showHeader={false} // Hide header since it's in a tab
    />
  );
};
